<template>
	<tab-layout-wrapper :tabs="tabs" />
</template>
<script>
import TabLayoutWrapper from '../components/wrappers/TabLayoutWrapper.vue'
export default {
	name: 'TabLayout',
	components: {
		TabLayoutWrapper
	},
	props: {
		tabs: {
			type: Array,
			default: () => []
		},
	}
}
</script>

